module.exports = __webpack_public_path__ + "img/现金流量表.a85d3b82.png";